import React, { useEffect, useState } from "react";
import FormStep from "./FormStep";
import { currencyFormat, dateFormat } from "../Utils";

const EventSelection = ({ nextStep, setFormData, formData }) => {
  const [availableEvents, setAvailableEvents] = useState([]);
  const [noEventsStatus, setNoEventsStatus] = useState(null);
  const [noEventsMessage, setNoEventsMessage] = useState("");

  useEffect(() => {
    // Get the form element
    const formElement = document.getElementById('lde-booking-form');
    
    if (formElement) {
      // Check for no events status
      if (formElement.dataset.noEventsStatus) {
        setNoEventsStatus(formElement.dataset.noEventsStatus);
        setNoEventsMessage(formElement.dataset.noEventsMessage || "There are no upcoming events at this time.");
        return;
      }

      // Check for a single event
      if (formElement.dataset.event) {
        try {
          const eventData = JSON.parse(formElement.dataset.event);
          setAvailableEvents([eventData]);
          
          // If there's only one event and none selected yet, auto-select it
          if (!formData.event) {
            setFormData((prev) => ({ ...prev, event: eventData }));
            nextStep();
          }
        } catch (e) {
          console.error("Error parsing event data:", e);
        }
        return;
      }

      // Check for multiple events
      if (formElement.dataset.events) {
        try {
          const eventsData = JSON.parse(formElement.dataset.events);
          setAvailableEvents(eventsData);
        } catch (e) {
          console.error("Error parsing events data:", e);
        }
      }
    }
  }, [nextStep, setFormData, formData.event]);

  const handleSelect = (event) => {
    setFormData((prev) => ({ ...prev, event }));
    nextStep();
  };

  if (noEventsStatus) {
    return (
      <FormStep
        title="Event Information"
        onBack={null}
        onNext={null}
      >
        <div className="lde-no-events">
          <p>{noEventsMessage}</p>
        </div>
      </FormStep>
    );
  }

  return (
    <FormStep 
      title="Choose an Event" 
      onBack={null} 
      onNext={null}
    >
      <div className="lde-events">
        {availableEvents.length === 0 ? (
          <div className="lde-loading">Loading events...</div>
        ) : (
          availableEvents.map((event) => (
            <div key={event.id} className={`lde-event-item ${formData.event && formData.event.id === event.id ? 'selected' : ''}`}>
              <div className="lde-event-item__thumbnail">
                <div className="image-wrap">
                  <div className="image">
                    {event.thumbnail ? (
                      <img src={event.thumbnail} alt={event.name} />
                    ) : (
                    <div className="logo"></div>
                    )}
                  </div>
                </div>
              </div>
              <div className="lde-event-item__content">
                <h3 className="lde-event-item__title">{event.name}</h3>
                <div className="lde-event-item__date">{dateFormat(event.date)}</div>
                <div className="lde-event-item__price">{currencyFormat(event.price)}</div>
                {event.description && (
                  <details className="lde-event-item__description">
                    <summary>View Description</summary>
                    <p>{event.description}</p>
                  </details>
                )}
                {event.venue && (
                  <div className="lde-event-item__venue">
                    <strong>Venue:</strong> {event.venue}
                  </div>
                )}
                <div className="lde-event-item__actions">
                  <div className="btn-wrap">
                    <button 
                      className="btn" 
                      onClick={() => handleSelect(event)}
                    >
                      Book now
                    </button>
                  </div>
                </div>
              </div>
            </div>
          ))
        )}
      </div>
    </FormStep>
  );
};

export default EventSelection;
